import { createSelector } from 'reselect';
import { array } from 'fp-ts';
import { getStringProp } from '@mews/fp';
import { composeProps } from '@mews/framework';
import { isHoldingState } from '@mews-commander/types';
import { getCurrentEnterpriseId } from '@mews-commander/core';
import { getResourceState } from '@mews-commander/legacy-entities/src/ducks/resources';
import { getCurrentEnterpriseIanaTimeZoneIdentifier } from '@mews-commander/legacy-entities/src/selectors/session/enterprise';
import { createDateGroups, getCheckedReservations } from '../../selectors';

const withEnterpriseIdExtender = (propSelector: $TSFixMe, key: $TSFixMe) =>
    createSelector(propSelector, getCurrentEnterpriseId, (propValue, enterpriseId) => ({
        enterpriseId,
        [key]: propValue,
    }));
const resourceIdExtender = withEnterpriseIdExtender(getStringProp('resourceId'), 'id');

// @ts-expect-error $TSFixMeError: Argument of type 'OutputSelector<ApplicationState, { [x: number]: unknown; enterpriseId: string; }, (res1: unknown, res2...
export const getCurrentEnterpriseResourceState = composeProps(getResourceState, resourceIdExtender);

const getCheckedHoldingReservations = createSelector(
    getCheckedReservations,
    array.filter(({ serviceOrderState }) => isHoldingState(serviceOrderState))
);
export const getCheckedReservationsFilteredDateGroups = createSelector(
    getCheckedHoldingReservations,
    getCurrentEnterpriseIanaTimeZoneIdentifier,
    (holdingCheckedReservations, timezone: string) =>
        array.isNonEmpty(holdingCheckedReservations) ? createDateGroups(holdingCheckedReservations, timezone) : []
);
